import React, { useEffect, useState } from 'react'
import PlantillaScreen from '../../helpers/PlantillaScreen'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { useBoxFiltros } from '../../CreditoyCobranza/ReporteCobranza/Helper/useBox';
import { GetKeyArray } from '../../../Helpers/GetKey';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { LoaderScreen } from '../../components/LoaderScreen';
import { FiltroListadoPrecioNuevo } from '../Inventario/FiltroListadoPrecioNuevo';
import { TablaListadoPrecios } from './TablaListadoPrecios';
import { FiltroBuscadoListadoPrecio } from '../Inventario/FiltroBuscadorListadoPrecio';


export const ListadoPreciosScreen = () => {
    const history = useHistory();
    const [filtroEstado, setFiltroEstado] = useState(false);
    const [keyFiltrado, setKeyFiltrado] = useState("")
    const [boxstate, setBoxState] = useBoxFiltros();
    const [state, setState] = useState({
        resumen: {},
        data: [],
    });
    const [data, setData] = useState([])
    const [datafiltro, setDatafiltro] = useState([])
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // console.log(datafiltro)

    useEffect(() => {
        ObtenerListado()
    }, []);

    const ObtenerListado = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `Inventario/ListadoActual`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result);
                setDatafiltro(result);


            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
    }

    const onExecute = () => {
        return new Promise((resolve, rejec) => {
            if (
                boxstate.ejercicioinicio === undefined ||
                boxstate.ejercicioinicio === null ||
                boxstate.ejercicioinicio === ""
            ) {
                rejec("Favor de agregar el ejercicio de inicio");
                return;
            }
            if (
                boxstate.periodoinicio === undefined ||
                boxstate.periodoinicio === null ||
                boxstate.periodoinicio === ""
            ) {
                rejec("Favor de agregar el periodo de inicio");
                return;
            }
            const fechainicio = new Date(
                boxstate.ejercicioinicio,
                Number(boxstate.periodoinicio) - 1,
                "01"
            );
            const fechafin = new Date(
                boxstate.ejerciciofin,
                Number(boxstate.periodofin) - 1,
                "01"
            );

            const ejercicio = boxstate.ejercicioinicio === 0 ? boxstate.ejercicio : boxstate.ejercicioinicio
            // const periodo = boxstate.periodoinicio === 0 ? 1 : boxstate.periodoinicio
            var sucursales = GetKeyArray(boxstate.pv.sucursal, ["idsucursal"]);
            var adr = GetKeyArray(boxstate.pv.adr, ["idadr"]);
            var periodo = GetKeyArray(boxstate.pk.periodo, ["idMes"]);
            if (sucursales === undefined || sucursales === null || sucursales === "") {
                sucursales = "0";
            }
            if (adr === undefined || adr === null || adr === "") {
                adr = "0";
            }
            if (periodo === undefined || periodo === null || periodo === "") {
                periodo = "0";
            }

            request
                .get(
                    `CumplimientoCondicionadas/ObtenerGeneral?ejercicio=${Number(ejercicio)}&sucursales=${sucursales}&adr=${adr}&periodo=${periodo}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    if (
                        result.result.detalle.length === undefined ||
                        result.result.detalle.length === null ||
                        result.result.detalle.length === 0
                    ) {
                        Swal.fire("LISTADO DE PRECIOS", "Sin solicitudes en esta sucursal", "warning");
                    }
                    // setCardSelected(1)
                    setState({
                        resumen: result.result.resumen,
                        data: result.result.detalle,
                    });
                    // setMeses(result.arrayMes)
                    // setTotales(result.totalesPorMes)
                    // setTableShow("G");
                    // setTitulo({
                    //     ...titulo,
                    //     show: result.result.resumen.titulo,
                    //     // ejercicio,
                    //     // sucursal,
                    // });
                    resolve("");
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    rejec(error);
                    return;
                });
        });
    };

    const onGeneraPDF = (datos) => {
        const mdl = (datos);
        setLoader({ ...loader, mostrar: true });
        request
            .post("Inventario/ImprimirListadoPDF", mdl)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const handleFiltrar = async () => {
        setFiltroEstado(true); // Activa la señal para la tabla
    };

    return (
        <PlantillaScreen
            titulo={"LISTADO DE PRECIOS DE MAQUINARIA SEMINUEVA"}
            className_main={1}
            className={"listado-precios-main-screen"}
        >
            <LoaderScreen loader={loader} />
            <div className='Contenedor-lista-precios-usado'>
                <div className="listado-precios-botones-pagina-container">
                    <div
                        className="listado-precios-actions-regresar"
                        onClick={() => history.push("/Usados/Main")}
                    >
                        <ArrowBackIcon />
                        Regresar
                    </div>
                    <div className="buttons">
                        <button className="PDF"
                            onClick={() =>
                                onGeneraPDF(datafiltro)
                            }
                            style={{ backgroundColor: '#940404' }}>
                            PDF
                        </button>
                    </div>
                </div>
                <FiltroBuscadoListadoPrecio
                    data={data}
                    datafiltro={datafiltro}
                    setDatafiltro={setDatafiltro}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    keyFiltrado={keyFiltrado}
                />
                <TablaListadoPrecios
                    datos={datafiltro}
                    ObtenerListado={ObtenerListado}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    setKeyFiltrado={setKeyFiltrado}
                />
            </div>
        </PlantillaScreen>
    )
}
